import { jsx as _jsx } from "react/jsx-runtime";
import { StyleSheet } from '@react-pdf/renderer';
import { usePDFContext } from './pdf.context';
const stylesTable = StyleSheet.create({
    container: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%'
    },
    header: {
        borderWidth: 1,
        borderColor: '#E1E1E1',
        borderTopRightRadius: 10,
        borderTopLeftRadius: 10,
        color: '#8A8A8A',
        fontSize: 10,
        fontWeight: 500,
        flexDirection: 'row',
        display: 'flex',
        width: '100%',
        padding: 10,
        paddingLeft: 15,
        paddingRight: 15
    },
    row: {
        borderWidth: 1,
        borderTop: 0,
        borderColor: '#E1E1E1',
        padding: 10,
        paddingLeft: 15,
        paddingRight: 15,
        color: '#545454',
        fontSize: 10,
        fontWeight: 500,
        width: '100%',
        display: 'flex',
        flexDirection: 'row'
    },
    footer: {
        borderWidth: 1,
        borderTopWidth: 0,
        borderColor: '#E1E1E1',
        backgroundColor: '#F7F7F7',
        borderBottomRightRadius: 10,
        borderBottomLeftRadius: 10,
        color: '#545454',
        fontSize: 10,
        fontWeight: 500,
        flexDirection: 'column',
        gap: 10,
        display: 'flex',
        width: '100%',
        padding: 10,
        paddingLeft: 15,
        paddingRight: 15
    },
    line: {
        flexDirection: 'row',
        display: 'flex',
        width: '100%'
    }
});
export const Table = ({ children }) => {
    const { View } = usePDFContext();
    return (_jsx(View, { style: stylesTable.container, children: children }));
};
export const TableHeader = ({ children }) => {
    const { View } = usePDFContext();
    return (_jsx(View, { style: stylesTable.header, children: children }));
};
export const TableRow = ({ children }) => {
    const { View } = usePDFContext();
    return (_jsx(View, { style: stylesTable.row, children: children }));
};
export const TableFooter = ({ children }) => {
    const { View } = usePDFContext();
    return (_jsx(View, { style: stylesTable.footer, children: children }));
};
export const TableCell = ({ children, width }) => {
    const { View } = usePDFContext();
    return (_jsx(View, { style: [{ width }], children: children }));
};
export const TableLine = ({ children, color }) => {
    const { View } = usePDFContext();
    return (_jsx(View, { style: [stylesTable.line, { color }], children: children }));
};
